import { useSetAtom } from "jotai";
import React from "react";
import styled from "styled-components";
import 히어로이미지1 from "../assets/hero.png";
import { screenAtom } from "../jotai/service";

const InventoryButton = () => {
  const setScreen = useSetAtom(screenAtom);

  return (
    <Container
      onClick={() => {
        setScreen("Inventory");
      }}
    >
      <CharacterImg src={히어로이미지1} alt="character" />
    </Container>
  );
};

export default InventoryButton;

const Container = styled.div`
  border: 2px solid black;
  border-radius: 8px;

  background-color: #fff;
  transition: 200ms;

  &:active {
    background-color: #ffffffa1;
  }
`;

const CharacterImg = styled.img`
  width: 80px;
  height: 80px;
  transition: 200ms;

  &:active {
    transform: scale(0.9);
  }
`;
